import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexSystemMasters from "./IndexSystemMaster";
import { guardElement } from "@comps/components";

const SystemMasterModules = () => {
  return (
    <Routes>
      <Route path="/" element={ guardElement(<IndexSystemMasters modkey="systemMasters" />, "systemMasters") } />
    </Routes>
  );
}

export default SystemMasterModules;
